'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _alert = require('../../alert');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertNeutral = function AlertNeutral(_ref) {
  var handleDismiss = _ref.handleDismiss,
      children = _ref.children;
  return _react2.default.createElement(
    _alert2.default,
    {
      className: 'alert-neutral cp-alert-neutral',
      handleDismiss: handleDismiss },
    children
  );
};

AlertNeutral.propTypes = {
  handleDismiss: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

exports.default = AlertNeutral;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/neutral/components/AlertNeutral.component.js
// module id = 877
// module chunks = 0 3